import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SLoader } from '@avalara/skylab-sdk/react';

import FilingOptionsSelector from './FilingOptionsSelector';
import FilingLanguageSelector from '../selectors/filing/FilingLanguageSelector';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReportGenerationOptions from './reports/ReportGenerationOptions';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';

const log = new Logger('FILING_PREPARATION', LOG_LEVELS.DEBUG);


class FilingPreparation extends Component {

  handleAfterTabSelected(selectedIndex, selectedPanel, selectedTabMenu, prevTabIndex, selectedTabId) {

      if(typeof this.props.onAfterTabSelected === 'function') {
        this.props.onAfterTabSelected(selectedIndex, selectedPanel, selectedTabMenu, this.props.selectedFilingOption, prevTabIndex, selectedTabId);
      }
  }

  render() {
    log.debug('render(): ', this.props);
    return (
      
      <div>
        <h2><LanguageStringResolver string='filingFilingPreparation' /></h2>
        <ApplicationMessages
          messageIds={[
            ALL_MESSAGES.VAT_BOOK_ALREADY_CLOSED,
            ALL_MESSAGES.FAILED_CLOSE_VAT_BOOK,
            ALL_MESSAGES.FAILED_CLOSE_VAT_RETURN,
            ALL_MESSAGES.FAILED_CLOSE_INTRASTAT
          ]}
          messageType="applicationError"
        />
        { this.props.vatReturnAutoFetchFailed ? (
            <ApplicationMessages messageIds={[ALL_MESSAGES.VAT_RETURN_AUTO_FETCH_FAILED]} messageType="applicationWarning" disableDismiss /> 
          ) : (<></>)
        }
        {
            this.props.returnGenerationPending ? (
              <ApplicationMessages messageIds={[ALL_MESSAGES.VAT_BOOKS_RETURNS_GENERATION_PENDING]}  messageType="applicationInfo"/>
            ) : (<></>)
        }
        {
            this.props.intrastatReturnGenerationPending ? (
              <ApplicationMessages messageIds={[ALL_MESSAGES.INTRASTAT_RETURNS_GENERATION_PENDING]}  messageType="applicationInfo"/>
            ) : (<></>)
        }
        {
            this.props.vatReturnGenerationPending ? (
              <>
                <div className="mb30" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} data-testid="vat-return-polling-loading">
                  <SLoader loading className="small" />
                  <span><LanguageStringResolver string='vatReturnGenerationAutoFetching' /></span>
                </div>
              </>
            ) : (<></>)
        }
        {
            !this.props.returnGenerationPending && !this.props.intrastatReturnGenerationPending && !this.props.vatReturnGenerationPending && !this.props.vatReturnAutoFetchFailed ? (
              <div className="float-left mr10">
                <FilingOptionsSelector
                  options={this.props.filingOptions}
                  selectionHandler={this.props.doSelectFilingOption}
                  selection={this.props.selectedFilingOption}
                  sorted={this.props.sortFilingOptions}
                  selectorLabelString={this.props.selectorLabelString}
                  disabled={this.props.disableFilingOptionSelector}
                />
              </div>
            ) : (<></>)
        }
        {
          (this.props.returnGenerationPending || this.props.intrastatReturnGenerationPending || this.props.vatReturnGenerationPending || this.props.vatReturnAutoFetchFailed) ? (<></>):
          (
            <>
              <div className="float-left">
                <FilingLanguageSelector
                  selection={this.props.selectedFilingOption}
                  filingLanguages = {this.props.modifiedAvailableFilingLanguages}
                  selectedLanguage={this.props.selectedLanguage}
                  selectionHandler={this.props.doSelectReportLanguage}
                />
              </div>
              <div className="clear"></div>
              <ApplicationMessages
                messageIds={[ALL_MESSAGES.MTD_SUBMISSION_WARNING]}
                messageType="applicationWarning"
              />
              {(this.props.enableNewIntrastatOpenReturnPage || this.props.enableAsyncVatReturnOpenReturnPage) && (
                <ApplicationMessages messageType="applicationWarning"  messageIds={[ALL_MESSAGES.REPORT_ALREADY_APPROVED]} />
              )}
              <div>
                <div className="clear"></div>
                
                  { (() => {
                    if (this.props.selectedFilingOption && this.props.userQuestions) {
                      return (
                      <div>
                        {this.props.tabOptionList && this.props.tabOptionList.length !== 0 ? (
                          <ReportGenerationOptions
                            title={this.props.title}
                            optionList={this.props.tabOptionList}
                            onAfterTabSelected={this.handleAfterTabSelected.bind(this)}
                          />
                        ) : ('')}
                      </div>
                      )
                    }
                  })()}
              </div>
            </>
          )
        }
      </div>
    );
  }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    canUserSaveToWorkflow: state.filing.canUserSaveToWorkflow,
    enableNewIntrastatOpenReturnPage: state.featureFlag?.data?.EnableNewIntrastatOpenReturnPage,
    enableAsyncVatReturnOpenReturnPage: state.featureFlag?.data?.EnableAsyncVatReturnOpenReturnPage
  };
}


FilingPreparation.defaultProps = {
  tabOptionList: [],
  sortFilingOptions: false,
  returnGenerationPending: false,
  intrastatReturnGenerationPending: false,
  vatReturnGenerationPending: false,
  vatReturnAutoFetchFailed: false
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(FilingPreparation);